import cx from 'classnames';
import { InputHTMLAttributes, ReactNode, Ref } from 'react';

import { SizeType } from '../types/base';
import styles from './input.module.scss';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'prefix'> {
  ref?: Ref<HTMLInputElement>;
  size?: SizeType;
  shape?: 'normal' | 'search' | 'visual' | 'inner';
  prefix?: ReactNode;
  suffix?: ReactNode;
  className?: string;
  isFull?: boolean;
  isError?: boolean;
}

export const Input = ({
  ref,
  size = 'large',
  shape = 'normal',
  prefix,
  suffix,
  isFull,
  className,
  isError,
  onChange,
  disabled,
  ...inputProps
}: InputProps) => {
  return (
    <div
      className={cx(styles.wrapper, styles[shape], className, {
        [styles[size]]: shape !== 'inner',
        [styles.isFull]: isFull,
        [styles.isError]: isError,
        [styles.disabled]: disabled,
      })}
    >
      {prefix}
      <input type='text' onChange={onChange} disabled={disabled} size={10} ref={ref} {...inputProps} />
      {suffix}
    </div>
  );
};
